export const sortSetup = (data?: Array<[string, string]> | null): string => {
	//const encode = (_: string[]) => _.map(encodeURIComponent).join(':')
	const encode = (_: string[]) => _.join(':')

	return data?.map(encode).join(',') ?? ''
}
